import { Request } from '../../components/funcs/BASES/Request'

import {
  GETALL_SUCCESS,
  GETONE_SUCCESS,
  CREATE_SUCCESS,
  UPDATE_SUCCESS,
} from '../types/BeslenmeCategory'


export const GetAllSuccess = data => {
  return {
    type: GETALL_SUCCESS,
    payload: data
  }
}

export const GetOneSuccess = data => {
  return {
    type: GETONE_SUCCESS,
    payload: data
  }
}

export const CreateSuccess = data => {
  return {
    type: CREATE_SUCCESS,
    payload: data
  }
}

export const UpdateSuccess = data => {
  return {
    type: UPDATE_SUCCESS,
    payload: data
  }
}


export const GetAll = (
    Data,
    before,
    after,
    onSuccess,
    onError,
  ) => dispatch => {
    Request(
      'GET',
      '/Auth/BeslenmeCategory',
      Data,
      data => {
        dispatch(GetAllSuccess(data))
      },
      () => {},

      before,
      after,
      onSuccess,
      onError,

      true,
      false,
    )
  }


export const GetOne = (
  Data,
  before,
  after,
  onSuccess,
  onError,
) => dispatch => {
  Request(
    'GET',
    '/Auth/BeslenmeCategory',
    Data,
    data => {
      dispatch(GetOneSuccess(data))
    },
    () => {},

    before,
    after,
    onSuccess,
    onError,

    true,
    false,
  )
}


export const Create = (
  Data,
  before,
  after,
  onSuccess,
  onError,
) => dispatch => {
  Request(
    'POST',
    '/Auth/BeslenmeCategory',
    Data,
    data => {
      dispatch(CreateSuccess(data))
    },
    () => {},

    before,
    after,
    onSuccess,
    onError,

    true,
    false,
  )
}


export const Update = (
  Data,
  before,
  after,
  onSuccess,
  onError,
) => dispatch => {
  Request(
    'PUT',
    '/Auth/BeslenmeCategory',
    Data,
    data => {
      dispatch(UpdateSuccess(data))
    },
    () => {},

    before,
    after,
    onSuccess,
    onError,

    true,
    false,
  )
}
